export const toRefiner_SearchPlaceholder = "cUF6E";
export const toRefiner_RemovePerson = "MCkbJ";
export const toRefiner_ClearSearch = "iu9okc";
export const toRefiner_Suggestions = "SvtAqe";
export const toRefiner_Loading = "Jwa6G";
export const toRefiner_NoSuggestions = "VFa4ed";
export const toRefiner_SelectedPerson = "Z7TCXd";
export const toRefiner_SelectedCount = "NKZuce";
export default {toRefiner_SearchPlaceholder,toRefiner_RemovePerson,toRefiner_ClearSearch,toRefiner_Suggestions,toRefiner_Loading,toRefiner_NoSuggestions,toRefiner_SelectedPerson,toRefiner_SelectedCount};